const googlePlay = 'https://play.google.com/store/apps/details?id=com.beforevaultapp';
const appStore = 'https://apps.apple.com/us/app/beforevault/id1667165865';
export {
    googlePlay,
    appStore
}   